import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords,
  canonical,
  ogImage = 'https://creativedirectorkhan.com/og-image.jpg',
  ogType = 'website',
  jsonLd
}) => {
  const siteTitle = 'CreativeDirectorKhan | KHAN';
  const fullTitle = title ? `${title} | ${siteTitle}` : `${siteTitle} - Creative Director, Cinematographer & Digital Strategist`;
  const defaultDescription = 'CreativeDirectorKhan | KHAN is a creative agency specializing in content and strategy — film production, digital marketing, branding, web development, and consulting. Serving clients worldwide.';
  
  return (
    <>
      <Helmet>
        {/* Primary Meta Tags */}
        <title>{fullTitle}</title>
        <meta name="title" content={fullTitle} />
        <meta name="description" content={description || defaultDescription} />
        {keywords && <meta name="keywords" content={keywords} />}
        {canonical && <link rel="canonical" href={canonical} />}
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content={ogType} />
        <meta property="og:title" content={fullTitle} />
        <meta property="og:description" content={description || defaultDescription} />
        <meta property="og:image" content={ogImage} />
        <meta property="og:site_name" content={siteTitle} />
        
        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:title" content={fullTitle} />
        <meta property="twitter:description" content={description || defaultDescription} />
        <meta property="twitter:image" content={ogImage} />
      </Helmet>

      {/* JSON-LD rendered outside Helmet for reliable injection */}
      {jsonLd && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
      )}
    </>
  );
};

export default SEO;
